import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import style from './ExerciseRun.module.css';
import {Translate} from 'react-redux-i18n';

import {
  changeVariableInput as changeVariableInputAction,
  submitVariable as submitVariableAction,
  copyVariables as copyVariablesAction,
  changeNewVariableKey as changeNewVariableKeyAction,
  changeNewVariableValue as changeNewVariableValueAction,
} from './VariablesActions';

import {
  showHideVariables as showHideVariablesAction,
} from './ExerciseRunActions';

class Variables extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      variables: {},
    }

    this._changeVariableInput = this._changeVariableInput.bind(this);
    this._submitVariable = this._submitVariable.bind(this);
    this._changeNewVariableKey = this._changeNewVariableKey.bind(this);
    this._changeNewVariableValue = this._changeNewVariableValue.bind(this);
    this._createVariable = this._createVariable.bind(this);
  }

  componentWillMount() {
    const { exercise, copyVariables } = this.props;

    const variables = exercise && exercise.variables;

    copyVariables(variables);
  }

  _changeVariableInput(e) {
    // console.log("VALUE", e.target.value, "CHECKED", e.target.checked);
    if(e.target.type === 'checkbox') {
      return this.props.changeVariableInput(e.target.dataset.variable, e.target.checked);
    }
    const valueInLowerCase = e.target.value.toLowerCase();
    if(["true", "false"].includes(valueInLowerCase)) {
      return this.props.changeVariableInput(e.target.dataset.variable, valueInLowerCase === "true");
    }
    const key = e.target.dataset.variable;
    const value = e.target.value;
    this.setState((prevState) =>{
      const updatedState = prevState.variables;
      updatedState[key] = value;
      return updatedState;
    })
    this.props.changeVariableInput(e.target.dataset.variable, e.target.value);
  }

  _changeNewVariableKey(e) {
    this.props.changeNewVariableKey(e.target.value);
  }

  _changeNewVariableValue(e) {
    this.props.changeNewVariableValue(e.target.value);
  }

  _submitVariable(e, key) {
    const { submitVariable, variableInput } = this.props;
    const variable = e.target.dataset.variable;

    // submitVariable(variable, variableInput[variable]);
    submitVariable(key, this.state.variables[key]);
  }

  _createVariable() {
    const { newVariableKey, newVariableValue, submitVariable } = this.props;

    submitVariable(newVariableKey, newVariableValue);
  }

  render() {
    const {
      loading,
      newVariableKey,
      newVariableValue,
      variableInput,
      showHideVariables,
    } = this.props;
    
    Object.keys(variableInput).forEach((key) => {
      if(typeof variableInput[key] === 'string' && ["true", "false"].includes(variableInput[key].toLowerCase())) {
        variableInput[key] = variableInput[key].toLowerCase() === "true" 
      }
    })

    return (
      <div>
        <h3 className={style.title}><strong><Translate value="exerciseRun.Variables"/></strong></h3>
        <a
          href="javascript:;"
          onClick={() => showHideVariables(false)}
          className={style.closeModal}
        ><i className="fas fa-times" /></a>
        <div className={`col-sm-12 ${style.variables} ${style.contentContainer} ${style.innerContainer}`}>
          {
            Object.keys(variableInput || {}).map(key => (
              <div className={`row ${style.variableList}`} key={key}>
                <div className="col-sm-3">
                  <strong className={style.key}>{key}:</strong>
                </div>
                <div className="col-sm-6">
                  {
                    typeof variableInput[key] === 'boolean'?
                    <input
                      type="checkbox"
                      className={`${style.communicationInput} form-check-input`}
                      data-variable={key}
                      checked={variableInput[key]}
                      onChange={this._changeVariableInput}
                    />
                    :
                    <input
                      className={style.communicationInput}
                      data-variable={key}
                      value={variableInput[key]}
                      onChange={this._changeVariableInput}
                    />
                  }
                </div>
                <div className="col-sm-3">
                  {
                    typeof variableInput[key] !== 'boolean' &&
                    <button
                      type="button"
                      data-variable={key}
                      className={`btn btn-small btn-primary ${style.communicationInput}`}
                      // onClick={this._submitVariable}
                      onClick={(e)=>this._submitVariable(e, key)}
                      disabled={loading}
                    >
                      <i
                        data-variable={key}
                        className={`fas fa-fw ${loading ? 'fa-circle-o-notch fa-spin' : 'fa-refresh'}`}
                      />
                        <Translate value="controls.Update"/>
                    </button>
                  }
                </div>
              </div>
            ))
          }
          <div className={`row ${style.variableList}`}>
            <div className="col-sm-3">
              <input
                className={style.communicationInput}
                value={newVariableKey}
                onChange={this._changeNewVariableKey}
              />
            </div>
            <div className="col-sm-6">
              <input
                className={style.communicationInput}
                value={newVariableValue}
                onChange={this._changeNewVariableValue}
              />
            </div>
            <div className="col-sm-3">
              <button
                type="button"
                className={`btn btn-small btn-default ${style.communicationInput}`}
                onClick={this._createVariable}
                disabled={loading}
              >
                <i
                  className={`fas fa-fw ${loading ? 'fa-circle-o-notch fa-spin' : 'fa-plus'}`}
                />
                <Translate value="controls.Add"/>
              </button>
            </div>
          </div>
        </div>
        <button
          type="button"
          className="btn btn-small btn-default"
          onClick={() => showHideVariables(false)}
        >
          <Translate value="controls.Close"/>
        </button>
      </div>
    );
  }
}

Variables.propTypes = {
  loading: PropTypes.bool,
  exercise: PropTypes.object,
  variableInput: PropTypes.object,
  newVariableKey: PropTypes.string,
  newVariableValue: PropTypes.string,
  changeVariableInput: PropTypes.func,
  submitVariable: PropTypes.func,
  copyVariables: PropTypes.func,
  changeNewVariableKey: PropTypes.func,
  changeNewVariableValue: PropTypes.func,
  showHideVariables: PropTypes.func,
};

const mapStateToProps = state => ({
  exercise: state.exercise.exercise,
  variableInput: state.exerciseVariables.variableInput,
  newVariableKey: state.exerciseVariables.newVariableKey,
  newVariableValue: state.exerciseVariables.newVariableValue,
  loading: state.exerciseVariables.loading,
});

const mapDispatchToProps = {
  changeVariableInput: changeVariableInputAction,
  submitVariable: submitVariableAction,
  copyVariables: copyVariablesAction,
  changeNewVariableKey: changeNewVariableKeyAction,
  changeNewVariableValue: changeNewVariableValueAction,
  showHideVariables: showHideVariablesAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Variables);

